import axios from '@axios'
import delegablePermissions from '@/utils/delegable-permissions'
import i18n from '@/libs/i18n'

const getInitialState = () => ({
  permissions: [],
})

export default {
  namespaced: true,
  state: getInitialState(),
  modules: {},
  getters: {
    getPermissionByValue: state => value =>
      state.permissions.find(p => p.permission === value),
  },
  mutations: {
    SET_PERMISSION(state, permissions) {
      state.permissions = permissions
    },

    CLEAN_STATE(state) {
      state.permissions = getInitialState()
    },
  },
  actions: {
    async fetchProfilesByPermissions({ commit }) {
      const permissions = Object.keys(delegablePermissions).map(
        key => delegablePermissions[key].permission
      )

      const { data } = await axios.post('/api/functionalities/accessProfiles', {
        permissions,
      })
      commit('SET_PERMISSION', data || [])
    },
    async getPermissionMessage({ getters }, actionPerm) {
      const permission = getters.getPermissionByValue(actionPerm)
      const listLength = permission.profiles.length
      const roles = permission.profiles.reduce(
        (accumulator, current) => `${accumulator} <br> - ${current.name}`,
        ''
      )
      return i18n.tc('PROFILES_PERMISSION', listLength, { roles })
    },
  },
}
